import active from './active';

const hover = (param) => active(param);

export default hover;
